import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  APIProvider,
  InfoWindow,
  Map,
  Pin,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import React, { useCallback, useEffect, useState } from "react";
import GetSvgIcon from "../../images/svglist";
import { Card, Col, ListGroup, Row } from "react-bootstrap";
import MarkerWarehouse from "../../images/MarkerWarehouse.png";
import LineHaulLogo from "../../images/LinehaulIco.png";
import { useAutocompleteSuggestions } from "./useAutocompleteSuggestions";

const Styles = {
  mapContainer: {
    height: "69vh",
    borderRadius: "0.5rem",
    overflow: "hidden"
  },
  geoSearchContainer: {
    height: "500px",
  },
  geoSbuList: {
    height: "460px",
  },
};

const locationsArr = [
  {
    key: "operaHouse",
    location: { lat: -33.8567844, lng: 151.213108 },
    isInfoWindow: false,
  },
  {
    key: "tarongaZoo",
    location: { lat: -33.8472767, lng: 151.2188164 },
    isInfoWindow: false,
  },
  {
    key: "manlyBeach",
    location: { lat: -33.8209738, lng: 151.2563253 },
    isInfoWindow: false,
  },
  {
    key: "hyderPark",
    location: { lat: -33.8690081, lng: 151.2052393 },
    isInfoWindow: false,
  },
  {
    key: "theRocks",
    location: { lat: -33.8587568, lng: 151.2058246 },
    isInfoWindow: false,
  },
  {
    key: "circularQuay",
    location: { lat: -33.858761, lng: 151.2055688 },
    isInfoWindow: false,
  },
  {
    key: "harbourBridge",
    location: { lat: -33.852228, lng: 151.2038374 },
    isInfoWindow: false,
  },
  {
    key: "kingsCross",
    location: { lat: -33.8737375, lng: 151.222569 },
    isInfoWindow: false,
  },
  {
    key: "botanicGardens",
    location: { lat: -33.864167, lng: 151.216387 },
    isInfoWindow: false,
  },
  {
    key: "museumOfSydney",
    location: { lat: -33.8636005, lng: 151.2092542 },
    isInfoWindow: false,
  },
  {
    key: "maritimeMuseum",
    location: { lat: -33.869395, lng: 151.198648 },
    isInfoWindow: false,
  },
  {
    key: "kingStreetWharf",
    location: { lat: -33.8665445, lng: 151.1989808 },
    isInfoWindow: false,
  },
  {
    key: "aquarium",
    location: { lat: -33.869627, lng: 151.202146 },
    isInfoWindow: false,
  },
  {
    key: "darlingHarbour",
    location: { lat: -33.87488, lng: 151.1987113 },
    isInfoWindow: false,
  },
  {
    key: "barangaroo",
    location: { lat: -33.8605523, lng: 151.1972205 },
    isInfoWindow: false,
  },
];

function round(value, decimals) {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

const findLocationsWithinRadius = (
  centerLocation,
  locations = [],
  radiusKm
) => {
  const { lat: centerLat, lng: centerLng } = centerLocation;
  const earthRadiusKm = 6371; // Earth's radius in kilometers

  const locationsWithinRadius = [];

  for (const location of locations) {
    // const { latitude: locLat, longitude: locLng } = location;
    if (typeof location.latLng === "string") {
      location.latLng = JSON.parse(location.latLng);
    }

    let locLat = location.latLng.lat;
    let locLng = location.latLng.lng;
    // Calculate the distance using the Haversine formula
    const dLat = (locLat - centerLat) * (Math.PI / 180);
    const dLng = (locLng - centerLng) * (Math.PI / 180);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(centerLat * (Math.PI / 180)) *
      Math.cos(locLat * (Math.PI / 180)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadiusKm * c;
    if (distance <= radiusKm) {
      location.distance = distance;
      locationsWithinRadius.push(location);
    }
  }

  return locationsWithinRadius;
};

const PoiMarkers = ({
  userLocation,
  locations,
  searchLocation,
  activeKey,
  toggleActiveLocation,
  onLocSelect,
}) => {
  return (
    <>
      {!!locations &&
        locations?.map((poi, index) => (
          <React.Fragment key={poi.value}>
            <AdvancedMarker
              position={poi.latLng}
              onClick={() => toggleActiveLocation(poi.value, poi.latLng)}
              anchorPoint={AdvancedMarkerAnchorPoint.TOP}
            >
              <img alt="Google Map" src={LineHaulLogo} width={32} height={32} />
            </AdvancedMarker>
            {activeKey === poi.value && (
              <InfoWindow
                className="font-12"
                position={poi.latLng}
                onClose={() => toggleActiveLocation("")}
                disableAutoPan={true}
                maxWidth={200}
                headerDisabled={true}
              >
                <div>
                  <div className="d-flex justify-content-between align-items-top w-100 pb-2">
                    <div>
                      <h5 className="mb-0 mt-0">{poi.sbuCode}</h5>
                    </div>
                    <div onClick={() => toggleActiveLocation(poi.value)}>
                      {GetSvgIcon("xCircleFill")}
                    </div>
                  </div>
                  <div className="mb-2">
                    <p className="form-label mb-1">{poi.address}</p>
                    <span className="badge bg-primary rounded-pill">
                      {poi.distance.toFixed(2)} KM
                    </span>
                  </div>
                  <div className="d-flex justify-content-center align-items-center ">
                    <button
                      className="btn btn-sm btn-primary theme-violet w-100"
                      onClick={() => {
                        onLocSelect(poi);
                      }}
                    >
                      Choose This SBU
                    </button>
                  </div>
                </div>
              </InfoWindow>
            )}
          </React.Fragment>
        ))}
      <AdvancedMarker key="userLocation" position={userLocation}>
        <div className="blue-dot-marker"></div>
      </AdvancedMarker>
      {/* Search Location Marker */}
      {searchLocation && searchLocation.lat && searchLocation.lng && (
        <AdvancedMarker key="searchLocation" position={searchLocation}>
          {GetSvgIcon("biGeoAltFillDangerXL")}
        </AdvancedMarker>
      )}
    </>
  );
};

// const Autocomplete = ({
//   onPlaceSelect,
//   serviceType,
//   inputText = ""
// }) => {
//   const [inputValue, setInputValue] = useState(inputText);

//   const places = useMapsLibrary('places');
//   const { suggestions, resetSession } = useAutocompleteSuggestions(inputValue);


//   const handleInput = useCallback((value) => {
//     setInputValue(value);
//   }, []);

//   const handleSuggestionClick = useCallback(
//     async (suggestion) => {
//       handleInput(suggestion?.placePrediction?.text?.text)
//       if (!places) return;
//       if (!suggestion.placePrediction) return;
//       const { Place } = places

//       const place = suggestion.placePrediction.toPlace();
//       await place.fetchFields({
//         fields: [
//           'id',
//           'location',
//         ]
//       });
//       let locationData;

//       // Only fetch detailed place information when serviceType is "CB"
//       if (serviceType === "CB") {
//         const placeDetails = new Place({
//           id: place?.Eg?.id,
//           requestedLanguage: 'en',
//         });
//         await placeDetails.fetchFields({ fields: ['formattedAddress', 'postalAddress', 'location'] });

//         locationData = {
//           sbuCode: "ADDRESS",
//           address: placeDetails?.Eg?.formattedAddress || suggestion?.placePrediction?.text?.text,
//           postalCode: placeDetails?.Eg?.postalAddress?.postalCode,
//           state: placeDetails?.Eg?.postalAddress?.administrativeArea,
//           city: placeDetails?.Eg?.postalAddress?.locality,
//           location: placeDetails?.Eg?.location || place?.Eg?.location
//         };
//       } else {
//         // For non-CB service types, use basic information
//         locationData = {
//           sbuCode: "ADDRESS",
//           address: suggestion?.placePrediction?.text?.text,
//           location: place?.Eg?.location
//         };
//       }
//       resetSession();
//       onPlaceSelect(locationData);
//     },
//     [places, onPlaceSelect, serviceType]
//   );

//   const clearInput = () => {
//     handleInput('');
//   };

//   return (
//     <div className="position-relative w-100">
//       <Row>
//         <div className="input-group ">
//           <input
//             className="form-control remove-rgt-border px-1"
//             placeholder="Type your address"
//             autoComplete="none"
//             value={inputValue}
//             onChange={(event) => handleInput((event.target).value)}
//           />
//           <span
//             className="d-flex align-item-center cross-design p-2"
//             onClick={clearInput}
//           >
//             &#x2715;
//           </span>
//           <button
//             type="button"
//             className="btn btn-primary theme-violet p-2"
//           // onClick={onSearch}
//           >
//             {GetSvgIcon("Search")}
//           </button>
//         </div>
//       </Row>
//       <div className="position-absolute z-1 w-100"  >
//         {suggestions.length > 0 && (
//           <ListGroup className="">
//             {suggestions.map((suggestion, index) => {
//               return (
//                 <ListGroup.Item
//                   key={index}
//                   action
//                   className=" py-2 suggestion-text"
//                   onClick={() => handleSuggestionClick(suggestion)}>
//                   <span className="text-info px-2 location-pin">
//                     {GetSvgIcon("BiGeoAltFillDanger")}
//                   </span>
//                   {suggestion.placePrediction?.text.text}
//                 </ListGroup.Item>
//               );
//             })}
//           </ListGroup >
//         )}
//       </div>
//     </div>
//   )
// }

const Autocomplete = ({
  onPlaceSelect,
  serviceType,
  inputText = ""
}) => {
  const [inputValue, setInputValue] = useState(inputText);

  const places = useMapsLibrary("places");
  const { suggestions, resetSession } = useAutocompleteSuggestions(inputValue);

  const handleInput = useCallback((value) => {
    setInputValue(value);
  }, []);

  const handleSuggestionClick = useCallback(
    async (suggestion) => {
      handleInput(suggestion?.placePrediction?.text?.text);
      if (!places) return;
      if (!suggestion.placePrediction) return;
      const { Place } = places;

      // Create a new Place instance with the placeId
      const placeObj = new Place({
        id: suggestion.placePrediction.placeId,
        requestedLanguage: 'en'  // optional: specify language
      });

      // Fetch the location field
      const response = await placeObj.fetchFields({
        fields: ['location']
      });

      let locationData = {
        sbuCode: "ADDRESS",
        address: suggestion?.placePrediction?.text?.text,
        location: null
      };

      try {
        if (!response?.place?.location) {
          throw new Error('No location data available');
        }

        const lat = response.place.location.lat();
        const lng = response.place.location.lng();

        if (typeof lat !== 'number' || isNaN(lat) ||
          typeof lng !== 'number' || isNaN(lng)) {
          throw new Error('Invalid coordinates received');
        }

        locationData.location = {
          lat: round(lat, 5),
          lng: round(lng, 5)
        };

        onPlaceSelect(locationData);

      } catch (error) {
        console.error('Error processing location:', error);
      }

      // Only fetch detailed place information when serviceType is "CB"
      // if (serviceType === "CB") {
      //   const placeDetails = new Place({
      //     id: place?.Eg?.id,
      //     requestedLanguage: 'en',
      //   });
      //   await placeDetails.fetchFields({ fields: ['formattedAddress', 'postalAddress', 'location'] });

      //   locationData = {
      //     sbuCode: "ADDRESS",
      //     address:
      //       placeDetails?.Eg?.formattedAddress ||
      //       suggestion?.placePrediction?.text?.text,
      //     postalCode: placeDetails?.Eg?.postalAddress?.postalCode,
      //     state: placeDetails?.Eg?.postalAddress?.administrativeArea,
      //     city: placeDetails?.Eg?.postalAddress?.locality,
      //     location: placeDetails?.Eg?.location || place?.Eg?.location,
      //   };
      // } else {
      //   // For non-CB service types, use basic information
      //   locationData = {
      //     sbuCode: "ADDRESS",
      //     address: suggestion?.placePrediction?.text?.text,
      //     location: place?.Eg?.location,
      //   };
      // }
      // resetSession();
      onPlaceSelect(locationData);
    },
    [places, onPlaceSelect, serviceType]
  );

  const clearInput = () => {
    handleInput("");
  };

  return (
    <>
      <div className="geo-search-container">
        <div className="geo-search-box d-flex flex-column w-100 h-100">
          <div className="d-flex w-100 flex-row">
            <input
              placeholder="Search Location"
              autoComplete="none"
              autoFocus={true}
              className={`form-control geo-search-input ${inputValue.length > 0 ? 'geo-search-input-with-clear' : 'geo-search-input-without-clear'}`}
              value={inputValue}
              onChange={(event) => handleInput(event.target.value)}
            />

            <span className="form-control geo-icon-container">
              {GetSvgIcon("Search")}
            </span>

            {inputValue.length > 0 && (
              <span
                className="geo-icon-container geo-clear-icon"
                onClick={clearInput}
              >
                &#x2715;
              </span>
            )}
          </div>
          {inputValue && suggestions.length > 0 && (
            <div className="geo-suggestions-dropdown">
              {suggestions.map((suggestion, index) => (
                <div
                  key={index}
                  onClick={() => handleSuggestionClick(suggestion)}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                  className="geo-suggestion-item"
                >
                  <span>{GetSvgIcon("BiGeoAltFillDanger")}</span>
                  <span className="geo-suggestion-text">
                    {suggestion?.placePrediction?.text?.text}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

const Geocoding = ({
  selectedLocationData,
  setSelectedLocationData,
  userLocation,
  showMap,
  setShowMap,
  locations,
  setUserLocation,
  setMapCenter,
  searchLocation,
  setSearchLocation,
  data,
  setLocations,
  setter,
}) => {
  const [address, setAddress] = useState("");
  const [showBtn, setShowBtn] = useState(-1);
  const map = useMap();
  const geocodingLib = useMapsLibrary("geocoding");

  useEffect(() => {
    if (showMap.show) {
      getUserLocation();
    }
  }, [showMap]);

  let locationToUse =
    showMap?.data?.addressData?.latLng?.lat &&
      showMap?.data?.addressData?.latLng?.lng
      ? showMap.data.addressData.latLng
      : userLocation?.lat && userLocation?.lng
        ? userLocation
        : { lat: 0, lng: 0 };

  useEffect(() => {
    locationToUse =
      showMap?.data?.addressData?.latLng?.lat &&
        showMap?.data?.addressData?.latLng?.lng
        ? showMap.data.addressData.latLng
        : userLocation?.lat && userLocation?.lng
          ? userLocation
          : { lat: 0, lng: 0 };
    if (!!map) map.setCenter(locationToUse);
  }, [map, userLocation]);

  // define the function that finds the users geolocation
  const getUserLocation = () => {
    // if geolocation is supported by the users browser
    if (navigator.geolocation) {
      // get the current users location
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // save the geolocation coordinates in two variables
          const { latitude, longitude } = position.coords;
          // update the value of userlocation variable
          setUserLocation({ lat: latitude, lng: longitude });

          setLocations(
            findLocationsWithinRadius(
              { lat: latitude, lng: longitude },
              data?.sbuArr,
              process.env.REACT_APP_RADIUS_IN_KM
            )
          );
        },
        // if there was an error getting the users location
        (error) => {
          console.error("Error getting user location:", error);
        },
        {
          enableHighAccuracy: true,
          maximumAge: 0,
          timeout: 30000,
        }
      );
    }
    // if geolocation is not supported by the users browser
    else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const onSearch = () => {
    if (!geocodingLib) return;

    const geocoder = new geocodingLib.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
      if (status === "OK") {
        const newLoc = JSON.parse(JSON.stringify(results[0].geometry.location));
        setMapCenter(newLoc);
        setLocations(
          findLocationsWithinRadius(
            newLoc,
            data?.sbuArr,
            process.env.REACT_APP_RADIUS_IN_KM
          )
        );
      } else {
        console.error(
          "Geocode was not successful for the following reason: " + status
        );
      }
    });
  };

  const onClear = () => {
    setAddress("");
    getUserLocation();
  };

  const onHoverSetIndex = (index) => {
    setShowBtn(index);
  };

  const onLocSelect = (argSbu) => {
    setter(argSbu);
    setShowMap({ show: false, data: {} });
  };

  // Handle place selection from Autocomplete
  const handlePlaceSelect = (locationData) => {
    setMapCenter(locationData.location);
    setSearchLocation(locationData.location);
    setSelectedLocationData(locationData);
  };

  const handleCenterMap = () => {
    if (!!map) map.setCenter(searchLocation);
  };

  return (
    // <div style={{
    //   height: '100%',
    //   position: 'relative'
    // }}>
    <>

      <Autocomplete
        onPlaceSelect={handlePlaceSelect}
        serviceType={showMap?.data?.serviceType}
        inputText={showMap?.data?.addressData?.fullAddress || ""}
      />
      {showMap?.data?.serviceType === "CB" &&
        <div className="input-group position-absolute" style={{
          bottom: '5%',
          left: '35%',
          zIndex: '1',
          width: '34%',
          height: '14%'
        }}>
          <div className="d-flex align-items-center w-100 h-100 bg-white rounded shadow" style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            overflow: 'hidden'
          }}>
            <div className="d-flex flex-column justify-content-center h-100 p-2" style={{
              width: '70%'
            }}>
              <div className="d-flex align-items-center mb-1">
                <div className="small text-secondary" style={{ width: '70px' }}>Latitude:</div>
                <div className="small fw-medium" style={{ fontSize: '0.85rem' }}>{selectedLocationData?.location?.lat}</div>
              </div>

              <div className="d-flex align-items-center">
                <div className="small text-secondary" style={{ width: '70px' }}>Longitude:</div>
                <div className="small fw-medium" style={{ fontSize: '0.85rem' }}>{selectedLocationData?.location?.lng}</div>
              </div>
            </div>

            <div
              className={`select-area d-flex align-items-center justify-content-center text-white h-100 ${!selectedLocationData?.location?.lat && !selectedLocationData?.location?.lng ? 'disabled' : ''
                }`}
              onClick={() => {
                if (selectedLocationData?.location?.lat || selectedLocationData?.location?.lng) {
                  onLocSelect(selectedLocationData);
                }
              }}
              aria-disabled={!selectedLocationData?.location?.lat && !selectedLocationData?.location?.lng}
            >
              <span>Select</span>
            </div>
          </div>
        </div>}

      {/* {showMap?.data?.serviceType === "CB" &&
        <div className="position-relative w-100 shadow rounded bg-white" style={{ marginTop: '2rem', height: '19rem' }}>
          <div className="w-100 h-100 d-flex flex-column">
         
            <div className="d-flex justify-content-between align-items-center w-100 p-3 bg-light border-bottom">
             
              <div className="d-flex align-items-center">
                {GetSvgIcon("BiGeoAltFillDanger")}
                <span className="ms-2 fw-bold">Location Details</span>
              </div>

              
              <button
                onClick={handleCenterMap}
                className="btn btn-sm d-flex align-items-center text-secondary"
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                title="Center map here"
              >
                {GetSvgIcon("crossHair", { size: 28 })}
              </button>
            </div>
            <div className="d-flex flex-column justify-content-start px-3 pt-3 overflow-auto flex-grow-1">
              <span className="text-secondary mb-3">
                {selectedLocationData?.address || "No address found"}
              </span>

              <div className="d-flex flex-wrap">
                <div className="me-4 mb-3">
                  <div className="text-muted small">City</div>
                  <div>{selectedLocationData?.city || "—"}</div>
                </div>

                <div className="me-4 mb-3">
                  <div className="text-muted small">State</div>
                  <div>{selectedLocationData?.state || "—"}</div>
                </div>

                <div className="mb-3">
                  <div className="text-muted small">Postal Code</div>
                  <div>{selectedLocationData?.postalCode || "—"}</div>
                </div>
              </div>

              <div className="d-flex flex-wrap text-secondary small mt-1">
                <div className="me-3">Lat: {(selectedLocationData?.location?.lat || userLocation?.lat)?.toFixed(6)}</div>
                <div>Long: {(selectedLocationData?.location?.lng || userLocation?.lng)?.toFixed(6)}</div>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center p-3 ">
              <button
                className="btn"
                style={{
                  fontFamily: "Inter, Roboto, sans-serif",
                  fontWeight: 500,
                  fontSize: "1rem",
                  letterSpacing: "0.5px",
                  color: "#fff",
                  backgroundColor: "#38B1AA",
                  border: "none",
                  borderRadius: "12px",
                  padding: "0.75rem 1.5rem",
                  width: "100%",
                  maxWidth: "300px",
                  boxShadow: "0 4px 10px rgba(56, 177, 170, 0.3)",
                  transition:
                    "background-color 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#2d958f";
                  e.currentTarget.style.boxShadow =
                    "0 6px 14px rgba(45, 149, 143, 0.4)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#38B1AA";
                  e.currentTarget.style.boxShadow =
                    "0 4px 10px rgba(56, 177, 170, 0.3)";
                }}
                onClick={() => onLocSelect(selectedLocationData)}
              >
                Confirm Location
              </button>
            </div>
          </div>
        </div>
      )}
      <Row>
        <div
          className="container-fluid overflow-auto mt-1"
          style={Styles.geoSbuList}
        >
          {locations.map((loc, index) => (
            <Card
              key={index}
              className="my-2 p-0 card-click cursor-pointer"
              onClick={() => onLocSelect(loc)}
              style={{
                transition: "transform 0.1s, box-shadow 0.1s",
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = "scale(0.98)";
                e.currentTarget.style.boxShadow = "0 0 5px rgba(0, 0, 0, 0.2)";
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 0 0 rgba(0, 0, 0, 0)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 0 0 rgba(0, 0, 0, 0)";
              }}
            >
              <Card.Header className="d-flex justify-content-between align-items-center p-2 theme-violet">
                {loc.sbuCode}
                {GetSvgIcon("chevronRight")}
              </Card.Header>
              <Card.Body className="p-2 font-12">{loc.address}</Card.Body>
            </Card>
          ))}
        </div>
      </Row> */}
      {/* </div> */}

    </>
  );
};

const getLocationDataFromCoordinates = (lat, lng, apiKey) => {
  return new Promise((resolve, reject) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (!data.results || data.results.length === 0) {
          reject(new Error("No address found for the given coordinates"));
          return;
        }

        // Get full formatted address
        const formattedAddress = data.results[0]?.formatted_address;
        const placeId = data.results[0]?.place_id;

        // Extract components from address_components
        const addressComponents = data.results[0]?.address_components;
        let postalCode = "";
        let state = "";
        let city = "";

        // Extract postal code, state and city from address components
        for (const component of addressComponents) {
          if (component.types.includes("postal_code")) {
            postalCode = component.long_name;
          }
          if (component.types.includes("administrative_area_level_1")) {
            state = component.long_name;
          }
          if (component.types.includes("locality")) {
            city = component.long_name;
          }
        }

        // Create a location object with the retrieved data
        const locationData = {
          sbuCode: "ADDRESS",
          address: formattedAddress,
          postalCode: postalCode,
          state: state,
          city: city,
          placeId: placeId,
          location: {
            lat: lat,
            lng: lng,
          },
        };

        resolve(locationData);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const LHMap = ({ showMap, setShowMap, data, setter }) => {
  const [userLocation, setUserLocation] = useState({ lat: 0, lng: 0 });
  const [locations, setLocations] = useState([]);
  const [activeKey, setActiveKey] = useState("");
  const [mapCenter, setMapCenter] = useState(null);
  const [searchLocation, setSearchLocation] = useState(showMap?.data?.addressData?.latLng || null);
  const [selectedLocationData, setSelectedLocationData] = useState({
    sbuCode: "ADDRESS",
    address: null,
    postalCode: null,
    state: null,
    city: null,
    placeId: null,
    location: {
      lat: round(showMap?.data?.addressData?.latLng?.lat || userLocation?.lat, 5) || null,
      lng: round(showMap?.data?.addressData?.latLng?.lng || userLocation?.lng, 5) || null
    }
  });

  const toggleActiveLocation = (locationKey) => {
    setActiveKey(locationKey === activeKey ? "" : locationKey);
  };
  const handleLocationSelect = (location) => {
    setShowMap({ ...showMap, show: false });
    if (setter && typeof setter === "function") {
      setter(location);
    }
  };
  const handleMapClick = async (event) => {
    const clickedLocation = event.detail.latLng;
    setSearchLocation(clickedLocation);
    setSelectedLocationData({
      sbuCode: "ADDRESS",
      address: null,
      postalCode: null,
      state: null,
      city: null,
      placeId: null,
      location: {
        lat: round(clickedLocation.lat, 5),
        lng: round(clickedLocation.lng, 5)
      }
    })
    // try {
    //   const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    //   const locationData = await getLocationDataFromCoordinates(
    //     clickedLocation.lat,
    //     clickedLocation.lng,
    //     apiKey
    //   );

    //   console.log("Extracted Location Data:", locationData);
    //   setSelectedLocationData(locationData);
    // } catch (error) {
    //   console.error("Error fetching location data:", error);
    // }
  };

  return (
    <APIProvider
      apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      onLoad={() => console.log("Maps API has loaded.")}
    >
      {/* <Row> */}
      {/* <Col md={4} style={Styles.geoSearchContainer}>
          <Geocoding
            userLocation={userLocation}
            showMap={showMap}
            setShowMap={setShowMap}
            setUserLocation={setUserLocation}
            mapCenter={mapCenter}
            selectedLocationData={selectedLocationData}
            setSelectedLocationData={setSelectedLocationData}
            setMapCenter={setMapCenter}
            searchLocation={searchLocation}
            setSearchLocation={setSearchLocation}
            data={data}
            locations={locations}
            setLocations={setLocations}
            setter={setter}
          />
        </Col> */}
      {/* <Col> */}
      <Geocoding
        userLocation={userLocation}
        showMap={showMap}
        setShowMap={setShowMap}
        setUserLocation={setUserLocation}
        mapCenter={mapCenter}
        selectedLocationData={selectedLocationData}
        setSelectedLocationData={setSelectedLocationData}
        setMapCenter={setMapCenter}
        searchLocation={searchLocation}
        setSearchLocation={setSearchLocation}
        data={data}
        locations={locations}
        setLocations={setLocations}
        setter={setter}
      />

      <Map
        mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
        defaultZoom={10}
        defaultCenter={userLocation}
        gestureHandling={"greedy"}
        center={mapCenter}
        onCameraChanged={(ev) => {
          setMapCenter(ev.detail.center);
        }
        }
        onClick={handleMapClick}
        mapTypeControl={false}
        fullscreenControl={false}
        streetViewControl={false}
        style={Styles.mapContainer}
      >
        <PoiMarkers
          userLocation={userLocation}
          locations={locations}
          activeKey={activeKey}
          searchLocation={searchLocation}
          mapCenter={mapCenter}
          toggleActiveLocation={toggleActiveLocation}
          onLocSelect={handleLocationSelect}
        />
      </Map>
      {/* </Col>
      </Row> */}
    </APIProvider>

    // <APIProvider
    //   apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
    //   onLoad={() => console.log("Maps API has loaded.")}
    // >
    //   <Autocomplete
    //     onPlaceSelect={handlePlaceSelect}
    //     serviceType={showMap?.data?.serviceType}
    //     inputText={showMap?.data?.addressData?.fullAddress || ""}
    //   />
    //   <Body />
    //   <Map
    //     mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
    //     defaultZoom={10}
    //     defaultCenter={{ lat: -33.8567844, lng: 151.213108 }}
    //     gestureHandling={"greedy"}
    //     mapTypeControl={false}
    //     fullscreenControl={false}
    //     streetViewControl={false}
    //     style={{
    //       height: "69vh",
    //       borderRadius: "0.5rem",
    //       overflow: "hidden"
    //     }}
    //   >
    //     <PoiMarkers
    //       userLocation={userLocation}
    //       locations={locations}
    //       activeKey={activeKey}
    //       searchLocation={searchLocation}
    //       mapCenter={mapCenter}
    //       toggleActiveLocation={toggleActiveLocation}
    //       onLocSelect={handleLocationSelect}
    //     />
    //   </Map>
    // </APIProvider>
  );
};

export default LHMap;
